import { Component } from '@angular/core';

@Component({
  selector: 'antm-logout',
  imports: [],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss',
})
export class LogoutComponent {

}
